export const frontmatter = {
    "draft": true,
    "title": "Auditoría",
    "sidebar_group": "referencia",
    "sidebar_label": "Auditoría",
    "sidebar_order": 12
}

export const toc = []